import { useNavigate, useParams } from "react-router-dom";
import { ProfileSuccessIcon } from "../../../../components/common/svg/AllSvg";
import CommonHeader from "../../../../components/common/layout/CommonHeader";
import { useTranslation } from "react-i18next";

const PublishedSuccess = () => {
    const params = useParams();
    const navigate = useNavigate();
    const { t } = useTranslation('common');

    return (
        <div className="w-full h-full bg-white dark:bg-bgDarkDull min-h-screen">
            <CommonHeader />
            <div className="flex flex-col gap-[3px] xlx:gap-[6px] items-center justify-center container max-w-[512px] my-[50px] sm:my-[100px] lg:my-[165px]">
                <ProfileSuccessIcon />
                <h3 className="text-primaryText dark:text-white font-bold mt-[10px] xlx:mt-[15px]">{t("recruitment.hr.success.title")}</h3>
                <h5 className="text-blackDull dark:text-textBlackDull font-medium text-center">{t("recruitment.hr.success.desc")}</h5>

                <button className="mt-[20px] xlx:mt-[30px] border border-primary xlx:h-[40px] h-[35px] flex items-center justify-center rounded-[6px] px-[20px] xlx:px-[29px] w-fit text-primary font-extrabold uppercase text-sm leading-snug focus:shadow-[0_0_0_3px_#059db25e] hover:shadow-[0_0_0_3px_#059db25e]" onClick={() => !!params?.lang ? navigate(`/${params?.lang}/admin/ads`) : navigate("/admin/ads")}>{t("recruitment.hr.success.view_list")}</button>
            </div>
        </div>
    );
};

export default PublishedSuccess;